import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfca63f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer relative" }
const _hoisted_2 = { class: "logo mb-[20px]" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content flex flex-row" }
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title font-bold" }, "友情连接", -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title font-bold" }, "快捷导航", -1))
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title font-bold" }, "联系我们", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copyright absolute bottom-0 left-0" }, "版权所有 © 广东省广晟财务有限公司 ICP备案：粤ICP备13083179号", -1))

import LogoSvg from "@/assets/images/logo.png";
import { useRouter } from "vue-router";
import { useStore } from '@/store/index'
import { reactive, watch, computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComp',
  setup(__props) {

const router = useRouter();
const footerInfo = reactive<{
	facultyName: Array<{ name: string, val: string }>,
	blogroll: Array<{ name: string, val: string }>,
}>({
	facultyName: [],
	blogroll: []
})
const store = useStore()

const curLogo = computed(() => {
    const list = store.state.navList
    const lastItem = list.length > 0 ? list[list.length - 1] : null
    if (lastItem?.logo) {
        return lastItem.logo
    }
    return LogoSvg
})

watch(() => store.state.configList, (val) => {
	if (store.state.configList?.length > 0) {
		const { facultyName, blogroll } = store.state.configList[0]
		footerInfo.facultyName = facultyName && JSON.parse(facultyName)
		footerInfo.blogroll = blogroll && JSON.parse(blogroll)
	}
}, { deep: true, immediate: true })

const forwardAboutus = (tab) => {

	switch (tab) {
		case 'background':
		case 'intro':
		case 'honors':
			router.push({
				path: '/aboutus',
				query: { tab }
			})
			break;
		case 'joinus':
			router.push('/joinus')
			break;
		case 'policies':
			router.push('/partyBuilding')
			break;
		case 'financial':
			router.push('/financial')
			break;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "img h-[56px] text-[#fff]",
        src: curLogo.value
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerInfo.blogroll, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.name
            }, [
              _createElementVNode("a", {
                href: item.val,
                target: "_blank"
              }, _toDisplayString(item.name), 9, _hoisted_7)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("ul", null, [
          _createElementVNode("li", {
            class: "cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (forwardAboutus('intro')))
          }, "公司概况"),
          _createElementVNode("li", {
            class: "cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (forwardAboutus('joinus')))
          }, "企业文化"),
          _createElementVNode("li", {
            class: "cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (forwardAboutus('honors')))
          }, "资质荣誉"),
          _createElementVNode("li", {
            class: "cursor-pointer",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (forwardAboutus('joinus')))
          }, "加入我们"),
          _createElementVNode("li", {
            class: "cursor-pointer",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (forwardAboutus('policies')))
          }, "国企党建"),
          _createElementVNode("li", {
            class: "cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (forwardAboutus('financial')))
          }, "金融服务")
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerInfo.facultyName, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "line",
              key: item.name
            }, _toDisplayString(item.name) + "：" + _toDisplayString(item.val), 1))
          }), 128))
        ])
      ])
    ]),
    _hoisted_12
  ]))
}
}

})